
const module = {
  namespaced: true,
  state:{
    module_marginTop:0,
    module_marginLeft:0,
    module_marginRight:0,
    btn_left:0,
    //用于按钮和搜索挂件调整大小
    btn_special:{
      top:0,
      height:0
    },
    min_width:0,

    //记录最终的百分比值，避免有损计算
    drag_val:{
      top:null,
      left:null,
      right:null,
      height:null
    },
    diff_val:0.4,//左右顶到头的差值

    //拖拽size特殊挂件
    drag_special:[
      'basic_button',
      'basic_searchs',
      'basic_webtitle',
      'basic_notice',
      'basic_progress',
      'basic_zhlanguage',
      'basic_loginregister'
    ],
    button_zoom:1



  },
  mutations:{

  },
  actions:{
  }

};


export default module;



// WEBPACK FOOTER //
// ./src/vuex/modules/module.js